export default "__VITE_ASSET__697dc2eb__"